// @flow

/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import Skeleton from '@ta/styleguide.skeleton';
import styles from './SuggestedFolloweesLoadingSkeleton.less';

const NUM_PROFILES_TO_RENDER = 3; // How many of those skeleton view profile sections to render

const SuggestedFolloweesLoadingSkeleton = () => (
  <div className={`ui_card section ${styles.container}`}>
    {Array.from(new Array(NUM_PROFILES_TO_RENDER), (val, index) => (
      <div className={styles.inner_container} key={index}>
        <div className={styles.avatar_cutout} />
        <div className={styles.avatar_vertical_bar} />
        <div className={styles.line_one_cutout} />
        <div className={styles.line_two_cutout} />
        <div className={styles.background}>
          <Skeleton height="100%" />
        </div>
      </div>
    ))}
  </div>
);

export default SuggestedFolloweesLoadingSkeleton;
